import { api } from "../api";


const BASE_URL = "/system-admin/employees";

export const getEmployeeById = (id) => {
  return api.get(`${BASE_URL}/${id}`);
};
